<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Toolbar class="p-mb-4">
          <template #start>
            <div style="font-size: 1.4em; color: inherit" class="p-mr-3">{{ $t('Employees') }}</div>
            <AddNewButton v-show="canModerate" :label="$t('Add')" class="p-mr-2" @click="addNewItem"/>
            <router-link v-show="canModerate" :to="{ path: `/employees-archive` }">
<!--              <Button :label="$t('Employees archive')" icon="ti-archive" class="p-button-secondary p-button-raised"/>-->
              <Button :label="$t('archive')" icon="ti-archive" class="p-button-secondary p-button-raised"/>
            </router-link>
          </template>
          <template #end>
            <SearchInput :disabled="dataTableIsLoading"
                         @change-processed-search-value="changeProcessedSearchValue"
                         v-model="searchData"
                         @show-spinner="isLoading = true"/>
          </template>
        </Toolbar>

        <Spinner v-if="isLoading"/>
        <DesktopDataTable v-else
                          :dataTableIsLoading="dataTableIsLoading"
                          :showHeader="false"
                          :itemsArrayIsEmpty="itemsArrayIsEmpty"
                          :sort="sort"
                          :showSearchInput="false"
                          :searchData="searchData"
                          :actionButtonsCount="actionButtonsCount"
                          @sort-items="sortItems"
                          @search-items="searchItems"
                          :headers="[
                            {name: '', title: '',  width: '60px', sortable: false},
                            {name: '', title: $t('Employee'),  width: '',sortable: false},
                            {name: 'birthdate', title: $t('Birthdate'), sortable: false},
                            {name: 'user.phone_number', title: $t('Phone'), sortable: false},
                            {name: 'work_phone_number', title: $t('Work Phone'), sortable: false},
                            {name: 'email', title: $t('Email'), sortable: false},
                            {name: 'last_login', title: $t('Last Login'), sortable: false},
                            {name: 'accounts', title: $t('Accounts'), sortable: false},
                            {name: 'roles', title: $t('roles'), sortable: false},
                            {name: 'created_at', title: $t('Created'), sortable: true},
                        ]">
          <template v-slot:body>
            <tr v-for="item of items"
                :key="item.id || item.uid"
                :class="{'updated-item': isItemUpdated(item.id)}">
              <td class="avatar-td">
                <AvatarsCell :employee="item"/>
              </td>
              <td>
                <div>{{ getCustomerLabel(item) }}</div>
                <div v-if="item.employee?.position" class="table-small-text p-text-secondary">{{ item.employee.position }}</div>
              </td>
              <td>
                <span v-if="item.birthdate">{{ formatBirthDate(item.birthdate) }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.phone_code && item.phone_number">
                  +{{ item.phone_code }} {{ item.phone_number }}
                </span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.employee?.work_phone_code && item.employee?.work_phone_number">
                  +{{ item.employee.work_phone_code }} {{ item.employee.work_phone_number }}
                </span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.email">{{ item.email }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.last_login">{{ formatDate(item.last_login) }}</span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <div class="p-badge"> {{ item.accountsCount || 0}}</div>
              </td>

              <td class="roles-column">
                <div v-if="item.access_map?.length" class="employee-access-list">
                  <div v-for="locationAccess of item.access_map"
                       :key="locationAccess.location_id"
                       class="employee-access-row">
                    <span class="employee-access-location">
                      {{ locationAccess.public_name }}:
                    </span>
                    <span class="role-badges-list">
                    <UserRoleBadge v-for="roleNum in getVisibleRoles(locationAccess.roles)"
                                   :key="`${locationAccess.location_id}-${roleNum}`"
                                   :role="roleNum"/>

                    <span v-if="getHiddenRolesCount(locationAccess.roles) > 0"
                          v-tooltip.top="getHiddenRoleNames(locationAccess.roles).join(', ')"
                          class="role-badge more">
                      +{{ getHiddenRolesCount(locationAccess.roles) }}
                    </span>
                  </span>
                  </div>
                </div>
                <i v-else class="ti-minus"/>
              </td>

              <td class="table-date-line">
                <span v-if="item.employee?.created_at">
                  {{ formatBy(item.employee.created_at, item.employee.creator) }}
                </span>
                <i v-else class="ti-minus"/>
              </td>

              <td v-show="actionButtonsCount">
                <div class="actions">
                  <router-link v-if="item.uid" :to="{ path: `/employees/${item.uid}` }">
                    <ViewButton/>
                  </router-link>
                  <EditButton v-show="canModerate"
                              :disabled="(disableEditButton && isItemUpdated(item.id)) || dataTableIsLoading"
                              @click="editItem(item)" />
<!--                  <DeleteButton v-show="canDelete"-->
<!--                                @click="confirmItemDelete(item, item.employee?.id)"-->
<!--                                :disabled="dataTableIsLoading || cannotDeleteEmployee(item)"/>-->
                </div>
              </td>
            </tr>
          </template>
        </DesktopDataTable>

        <OwnPaginator v-show="!itemsArrayIsEmpty"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11"/>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>

        <EmployeeModal :visible="itemModal"
                     :item="item"
                     @update-items="updateItems"
                     @close="closeItemModal"/>

<!--        <ConfirmDeleteModal :visible="confirmItemDeleteModal"-->
<!--                            :modalDataIsLoading="modalDataIsLoading"-->
<!--                            @close="closeConfirmItemDeleteModal"-->
<!--                            @delete-item="deleteItem"-->
<!--                            :data="itemToDeleteData"/>-->
			</div>

		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import formatMixins from '@/mixins/formatMixins'
import httpMixins from "@/mixins/httpMixins";
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import AvatarsCell from "@/components/AvatarsCell";
import EmployeeModal from "@/pages/employees/components/EmployeeModal.vue";
import roles from "@/translations/roles";
import labelMixin from "@/mixins/labelMixin";
import UserRoleBadge from "@/components/UserRoleBadge.vue";

export default {
  mixins: [ formatMixins, httpMixins, datatableMixins, labelMixin ],
  components: { EmployeeModal, AvatarsCell, UserRoleBadge },
	data() {
		return {
      fieldsExpand: 'employee.creator,access_map,accountsCount,max_role_with_archived',
      apiLink: 'employee',
      deleteItemUrl: 'employee/delete',
      routePath: '/employees',
		}
	},
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    this.getPageData()
	},
  methods: {
    getPageData() {
      this.getItems()
    },
    async getItems() {
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      this.disableEditButton = true
      const ctrl = this.setController?.('employees')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          // method: 'post',
          params: {
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.processedSearchValue ?? null,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal
        })
        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.items = []
          this.showUnknownError()
        }
      } catch(err) {
        this.items = []
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.isLoading = false
        this.dataTableIsLoading = false
        this.disableEditButton = false
        if (this._abortors?.employees === ctrl) {
          this._abortors.employees = null
        }
      }
    },
    getVisibleRoles(roleNums = [], limit = 3) {
      return this.getSortedRoles(roleNums).slice(0, limit)
    },
    // getSortedRoles(roleNums = []) {
    //   return [...roleNums].sort((a, b) => a - b);
    // },
    getSortedRoles(roleNums = []) {
      if (!Array.isArray(roleNums)) return []

      return [...roleNums].sort((a, b) => a - b)
    },

    getRoleName(roleNum) {
      const role = roles.find(item => item.num === roleNum);
      if (!role) {
        return String(roleNum);
      }

      return role.name?.[this.$i18n.locale] || role.name?.en || String(roleNum);
    },

    getVisibleRoleNames(roleNums = [], limit = 3) {
      return this.getSortedRoles(roleNums)
          .slice(0, limit)
          .map(roleNum => this.getRoleName(roleNum));
    },

    getHiddenRoleNames(roleNums = [], limit = 3) {
      return this.getSortedRoles(roleNums)
          .slice(limit)
          .map(roleNum => this.getRoleName(roleNum));
    },

    getHiddenRolesCount(roleNums = [], limit = 3) {
      return Math.max(this.getSortedRoles(roleNums).length - limit, 0);
    },
    // cannotDeleteEmployee(user) { { //DONT DELETE!!!
    //   if (!user) return true
    //
    //   const targetId = Number(user?.id || 0)
    //   const currentId = Number(this.$store.getters.userData?.id || 0)
    //
    //   if (targetId === currentId || !this.$store.getters.isOwnerOrHigher) return true
    //
    //   return false
    // },
	},
  computed: {
    canModerate() {
      return this.$store.getters.isAccountantOrHigher
    },
    // canDelete() {
    //   return this.$store.getters.isOwnerOrHigher
    // },
    actionButtonsCount() {
      // if (this.canDelete) {
      //   return 3
      // } else
      if (this.canModerate) {
        return 2
      } else {
        return 0
      }
    },
    itemToDeleteData() {
      if (!this.itemToDelete) return null
      return this.getCustomerLabel(this.itemToDelete)
    }
  }
}
</script>

<style scoped lang="scss">
//.more-roles {
//  cursor: pointer;
//  opacity: 0.8;
//}
//.more-roles:hover {
//  opacity: 1;
//}
//
//.roles-column {
//  font-size: 0.9rem;
//  line-height: 1.3;
//  min-width: 200px;
//}

.roles-column {
  font-size: 0.9rem;
  line-height: 1.4;
  min-width: 240px;
}

.employee-access-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

.employee-access-row + .employee-access-row {
  margin-top: 10px!important;
}

.employee-access-location {
  //font-weight: 500;
  margin-right: 2px;
}
</style>
